module.exports = __webpack_public_path__ + "static/media/tech-dummies.da4c9fad.jpg";